import { useState, useCallback } from "react";
import az from "../locales/az";
import en from "../locales/en";
import ru from "../locales/ru";

const LOCALES = { az, en, ru };

export function useTranslation() {
  const [lang, setLang] = useState(() => {
    try { return localStorage.getItem("ck_lang") || "az"; } catch { return "az"; }
  });

  const t = LOCALES[lang] || LOCALES.az;

  const changeLang = useCallback((code) => {
    if (!LOCALES[code]) return;
    try { localStorage.setItem("ck_lang", code); } catch {}
    setLang(code);
    const titles = {
      az: "CodeKloud Academy — İT Təlim Mərkəzi",
      en: "CodeKloud Academy — IT Training Center",
      ru: "CodeKloud Academy — Центр IT обучения",
    };
    document.title = titles[code] || titles.az;
  }, []);

  return { lang, t, changeLang };
}
